/**
 * ConsentService — Enregistre les consentements user en BD (Apple 1.1 audit trail).
 * POST /consent → table user_consents (user_id, consent_type, accepted_at, ip, app_version).
 * Fire-and-forget : n'interrompt jamais le flux utilisateur si l'appel échoue.
 */
import { AWS_CONFIG } from '../config/aws_config';

export async function recordConsent({ authToken, consentType = 'personal_tryon_18plus', metadata = {} }) {
  if (!authToken) return { success: false };
  let appVersion = '';
  try { appVersion = require('../../app.json').expo?.version || ''; } catch (_) {}
  try {
    const res = await fetch(`${AWS_CONFIG.apiUrl}/consent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${authToken}` },
      body: JSON.stringify({ consent_type: consentType, app_version: appVersion, metadata }),
    });
    const data = await res.json().catch(() => ({}));
    return { success: !!data.success, ...data };
  } catch (e) {
    console.warn('[ConsentService] recordConsent failed:', e?.message);
    return { success: false };
  }
}

export default { recordConsent };
